/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/jsx-key */
import React from 'react';
import { Button, Table } from 'reactstrap';
import { MdClose } from 'react-icons/md';
import CardWithTitle from 'components/CardWithTitle';
import NoDataFound from 'components/NoDataFound';
import TraderField from '../TraderField';

const AllocateVendors = ({ rest }) => {
  const { values, setFieldValue } = rest;
  const handleRemove = (id) => {
    const newValues = values.assignedTraders.filter(
      (selectedItem) => selectedItem?.id !== id,
    );

    setFieldValue('assignedTraders', newValues);
  };

  return (
    <>
      <CardWithTitle title="Allocate Vendor">
        <TraderField
          isMulti
          name="assignedTraders"
          label="Vendor"
          type="select"
          // defaultValue={values?.assignedTraders}
          // {...rest}
          value={values?.assignedTraders}
        // {...props}
        // required
        />
      </CardWithTitle>
      <div className="table-border">
        <Table responsive className="common-table mb-0">
          <thead>
            <tr>
              <th>Vendor</th>
              <th>Phone Number</th>
              <th>Email</th>
              {/* <th></th> */}
            </tr>
          </thead>
          <tbody>
            {values?.assignedTraders?.length ? (
              values?.assignedTraders.map((item) => {
                return (
                  <tr>
                    <td>{item?.vendorName || '-'}</td>
                    <td>{item?.phone || '-'}</td>
                    <td>{item?.email || '-'}</td>
                    <td>
                      <Button
                        outline
                        color="link"
                        className="text-dcoration-none border-0 text-primary"
                        onClick={() => handleRemove(item?.id)}
                      >
                        <MdClose />
                      </Button>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={3}>
                  <NoDataFound message="No data found" />{' '}
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      {/* <FSBTable
        data={values?.assignedTraders || []}
        totalCount={values?.assignedTraders?.length || 0}
        totalPages={0}
        columns={allocateVendorColumns}
        //   currentPageNo={filters.pageNo}
        pageSize={values?.assignedTraders?.length}
        keyField="id"
        showFilters
        remote
        wrapperClass="table-responsive word-break"
      /> */}
    </>
  );
};

export default AllocateVendors;
